var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.enviarDatos}},[_vm._v("Enviar evento al servidor")])])}
var staticRenderFns = []

export { render, staticRenderFns }